import React, {createRef} from 'react'

import FormManager from "../../gd-form/common/form-manager"
import GDFormModal from "../../gd-form/form/form-modal-new/form-modal-new"
import FormElementInput from "../../gd-form/form-element/input/input"
import FormError from "../../gd-form/common/form-error/form-error"

type Props = {
    fieldName       : string
    currentValue    : string

    onSubmit        : callback
}

// const debug = "ModalRename"
const debug = false

class ModalRename extends React.Component<Props> {

    private form: FormManager
    private refInput: any = createRef()

    constructor(props: Props) {
        super(props);

        const initFormData = {
            name: this.props.currentValue
        }

        const formStructure = {
            fields: {
                name: {
                    type: 'input',
                    isRequired: true
                }
            },
            onSubmit: this.onSubmit
        }

        this.form = new FormManager(formStructure,initFormData);
    }

    componentDidMount() {
        this.refInput.current.focus()
    }

    onKeyDown = (e: KeyboardEvent) => {
        debug && console.log(debug, 'onKeyDown', e)

        switch (e.key) {
            case "Enter":
                e.preventDefault();
                this.props.onSubmit(this.form.getValues())
                break;
            case "Escape":
                e.preventDefault();
                gd.modal.hide()
                break;
        }
    }

    onSubmit = (result: any) => {
        this.props.onSubmit(result);
    }

    render() {
        return (
            <GDFormModal form={this.form} submitLabel="Save" >
                <div className="tbl">
                    <div className="row">
                        <div className="label">{_.get(this.props,'fieldName','Name')}</div>
                        <div className="element">
                            <FormElementInput ref           = {this.refInput}
                                              size          = "big"
                                              form          = {this.form}
                                              name          = "name"
                                              selectOnFocus = {true}
                                              onKeyDown     = {this.onKeyDown}/>
                            <FormError form={this.form} name="name" />
                        </div>
                    </div>
                </div>
            </GDFormModal>
        );
    }
}

module.exports = ModalRename